import { Loader2 } from 'lucide-react'
import type React from 'react'
import { Navigate } from 'react-router'

import { hasAccess } from '@langmail/auth-config/access'
import { useAuth } from '@langmail/shared-ui'

interface ProtectedRouteProps {
  children: React.ReactNode
  /** Off for the subscribe page itself, which must stay reachable after the trial. */
  requireSubscription?: boolean
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireSubscription = true }) => {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-linear-to-br from-background to-card">
        <div className="flex items-center space-x-2">
          <Loader2 className="h-6 w-6 animate-spin" />
          <span>Loading...</span>
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate replace to="/login" />
  }

  // Same rule the auth service applies at the OIDC authorize step, so the
  // web app and agent access agree on who is in and who is out.
  if (requireSubscription && !hasAccess(user)) {
    return <Navigate replace to="/subscribe" />
  }

  return <>{children}</>
}
